<template>
  <div>
    <div class="filtrateBox">
      <div class="List">
        <div
          :class="['grade', yearIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': yearList.length + 3 - index,
          }"
          v-for="(item, index) in yearList"
          :key="index"
          @click="yearSelest(index)"
        >
          {{ item.Name }}
        </div>
      </div>

      <div class="List">
        <div
          :class="['grade', CycleIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': CycleList.length + 3 - index,
          }"
          v-for="(item, index) in CycleList"
          :key="index"
          @click="CycleSelect(index)"
        >
          {{ item.Name }}
        </div>
      </div>

      <div class="List">
        <div
          :class="['grade', classIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': classList.length + 3 - index,
          }"
          v-for="(item, index) in classList"
          :key="index"
          @click="ClassSlect(index)"
        >
          {{ item.Name }}
        </div>
      </div>

      <div class="List">
        <div
          :class="['grade', CategoryIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': CategoryList.length + 3 - index,
          }"
          v-for="(item, index) in CategoryList"
          :key="index"
          @click="cateSelect(index)"
        >
          {{ item.CateName }}
        </div>
      </div>
      <!-- <div class="List">
        <div v-for="(item, index) in CategoryList" :key="index">
          <el-button
            :type="CategoryIndex == index ? 'primary' : ''"
            size="mini"
            round
            @click="cateSelect(index)"
            >{{ item.CateName }}</el-button
          >
        </div>
      </div> -->
      <div class="btnList" v-if="userInfo.UserIdentity.indexOf('2') != -1">
        <el-button
          size="mini"
          @click="toTest(true)"
          :disabled="uId.length == 0"
          type="primary"
          >批量评价</el-button
        >
        <!-- <el-button size="mini" type="primary">历史数据导入</el-button>
        <el-button size="mini" type="primary">导入模板下载</el-button> -->
      </div>
    </div>
    <div class="table">
      <el-table
        :data="studentList"
        ref="multipleTable"
        border
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
        }"
        empty-text="暂无数据"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :selectable="Selectable"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column type="index" align="center" label="序号" width="55">
        </el-table-column>
        <el-table-column prop="StudyYearName" align="center" label="学届">
        </el-table-column>
        <el-table-column prop="GradeName" align="center" label="年级">
        </el-table-column>
        <el-table-column prop="ClassName" align="center" label="班级">
        </el-table-column>
        <el-table-column prop="StudentName" align="center" label="学生姓名">
        </el-table-column>
        <el-table-column prop="Sex" align="center" label="性别">
        </el-table-column>
        <el-table-column
          align="center"
          label="佐证"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
        >
          <template slot-scope="scope">
            <div
              style="color: #4cbff4; cursor: pointer"
              v-if="scope.row.IsTearer == 0"
              @click="proofadd(scope.row)"
            >
              上传
            </div>
            <div
              style="color: #4cbff4; cursor: pointer"
              @click="AdminGetTearevalInfoByStudentCate(scope.row)"
              v-else
            >
              查看
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="佐证"
          v-if="userInfo.UserIdentity.indexOf('2') == -1"
        >
          <template slot-scope="scope">
            <div
              style="color: #4cbff4; cursor: pointer"
              v-if="scope.row.IsTearer == 0"
            >
              未上传
            </div>
            <div
              style="color: #4cbff4; cursor: pointer"
              @click="AdminGetTearevalInfoByStudentCate(scope.row)"
              v-else
            >
              查看
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="学期寄语"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
        >
          <template slot-scope="scope">
            <div
              style="color: #4cbff4; cursor: pointer"
              v-if="scope.row.IsMessage == 0"
              @click="toWrite(scope.row)"
            >
              填写
            </div>
            <div
              style="color: #4cbff4; cursor: pointer"
              @click="AdminGetTearMessageInfoByStudent(scope.row)"
              v-else
            >
              编辑
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="学期寄语"
          v-if="userInfo.UserIdentity.indexOf('2') == -1"
        >
          <template slot-scope="scope">
            <div
              style="color: #4cbff4; cursor: pointer"
              v-if="scope.row.IsMessage == 0"
            >
              未填
            </div>
            <div
              style="color: #4cbff4; cursor: pointer"
              @click="AdminGetTearMessageInfoByStudent(scope.row)"
              v-else
            >
              查看
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="评价状态"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.IsTest == 0"
              @click="toTest(false, scope.row)"
              >前往评价</el-button
            >
            <el-button
              size="mini"
              type="warning"
              v-else
              @click="toTest(false, scope.row)"
              >重新评价</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="评价状态"
          v-if="userInfo.UserIdentity.indexOf('2') == -1"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="scope.row.IsTest == 0"
              >未评</el-button
            >
            <el-button size="mini" type="warning" v-else>已评</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </div>
    <!-- 佐证评价 -->
    <el-dialog
      :title="
        proofDialogVisible
          ? '(' +
            updateUser.StudentName +
            ')' +
            CategoryList[CategoryIndex].CateName
          : ''
      "
      :visible.sync="proofDialogVisible"
      width="800px"
      @opened="dialogOpen"
    >
      <el-dialog
        width="30%"
        title="云盘列表"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="CloudStorageImageBox">
          <div
            class="CloudStorageImageItem"
            v-for="(itemImage, indexImage) in CloudStorageImage"
            :key="indexImage"
            @click="selectImage(indexImage)"
          >
            <div class="check"><div v-if="itemImage.isCheck"></div></div>
            <img :src="itemImage.FileUrl" alt="" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="affirmSelectImage"
            >确认选择</el-button
          >
        </span>
      </el-dialog>
      <div>
        <div class="statueTesting">
          <div class="statueTesting_title">照片类别（最多3张）</div>
        </div>
        <div style="margin-top: 20px">
          <el-button
            size="mini"
            round
            type="primary"
            :disabled="imgFilesLists.length >= 3"
            @click="showCloudStorage"
            >蘑菇云盘获取</el-button
          >
        </div>
        <div class="UpdateBox">
          <div
            class="imageBox"
            v-for="(item, index) in imgFilesLists"
            :key="index"
          >
            <img
              src="../../assets/delete.png"
              @click="handleUploadRemove(index)"
              class="deleteIcon"
              alt=""
            />
            <img :src="item" alt="" />
          </div>
          <el-upload
            v-if="imgFilesLists.length < 3"
            action="/api/Img/UploadImage/"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeAvatarUpload"
            :headers="token"
            :limit="3"
            :multiple="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          @click="AdminSaveTearevalInfoByStudentCate"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <!-- 学期寄语 -->
    <el-dialog
      :title="wordDialogVisible ? updateUser.StudentName : ''"
      :visible.sync="wordDialogVisible"
      width="800px"
    >
      <div>
        <div class="statueTesting">
          <div class="statueTesting_title">老师寄语</div>
        </div>
        <div style="padding-top: 20px">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
            placeholder="请输入学期寄语"
            v-model="wordText"
          >
          </el-input>
        </div>
        <prefabricatedText
          :maxTextLength="140"
          MessageType="666"
          @select="wordTextSelect"
        ></prefabricatedText>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
          @click="AdminSaveTearMessageInfoByStudent"
          >提交</el-button
        >
      </span>
    </el-dialog>

    <!-- 评价提示  -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisiblelable"
      :before-close="CloseDialoglabal"
      width="25%"
      title="温馨提示"
    >
      <div v-if="userInfo.SchoolType==2">
        <img
          class="hintTable"
          src="../../assets/hintTablex.png"
          alt=""
          srcset=""
        />
        <div class="lable_desc">
          当学生已稳定达到“水平1”却与“水平3”尚有差距时，其处于“水平2”阶段，同理，以稳定达到“水平3”却与“水平5”尚有差距时，其处于“水平4”阶段。
        </div>
      </div>
      <div v-else>
        <img
          class="hintTable"
          src="../../assets/hintTable.png"
          alt=""
          srcset=""
        />
        <div class="lable_desc">
          当幼儿已稳定达到“表现行为1”却与“表现行为3”尚有差距时，其处于“表现行为2”阶段，同理，以稳定达到“表现行为3”却与“表现行为5”尚有差距时，其处于“表现行为4”阶段。
        </div>
      </div>
      <el-button slot="footer" @click="onSubmitLable" size="mini" type="primary"
        >我已知晓，开始评价</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import {
  getAcademicSelect,
  GetClassSelect,
  GetGradeList,
  GetOpenCycleInfoSelectResult,
  AdminGetTestStatusInfo,
  AdminGetTearevalInfoByStudentCate,
  AdminSaveTearevalInfoByStudentCate,
  AdminGetTearMessageInfoByStudent,
  AdminSaveTearMessageInfoByStudent,
  FrontGetQuestionCategoryNodes,
  GetCloudFilePageingByFolderId,
} from "@/api/api";
import prefabricatedText from "../../components/PrefabricatedText.vue";

export default {
  data() {
    return {
      userInfo: {}, //UserIdentity  0:管理员   1:园长   2:教师   3:家长
      yearList: [],
      yearIndex: 0,
      GradeList: [],
      GradeIndex: 0,
      classList: [],
      classIndex: 0,
      CategoryIndex: 0,
      CategoryList: [],
      CycleList: [],
      CycleIndex: 0,
      tableHeader: [],
      studentList: [],
      PageIndex: 1,
      PageSize: 10,
      countNum: 0,
      uId: [], //多选学生信息
      proofDialogVisible: false,
      updateUser: {}, //操作的人员信息
      currentIndex: 0, //佐证上传类型 0本地上传 1云盘选取
      token: {
        Authorization: "Bearer ",
      },
      wordDialogVisible: false,
      imgFilesLists: [],
      wordText: "",
      loading: null,
      dialogVisiblelable: false, // 评价提示
      isBatch: false,
      CloudStorageImage: [],
      innerVisible: false,
      total: 0,
      StudentId: 0,
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    console.log(this.userInfo)
    this.getAcademicSelect();
    //console.log("创建");
  },
  destroyed() {
    //console.log("销毁");
  },
  components: {
    prefabricatedText,
  },
  methods: {
    wordTextSelect(e) {
      this.wordText = e.content;
    },
    //我已知晓
    onSubmitLable() {
      this.dialogVisiblelable = false;
      let dateInfo = {
        SId: this.CategoryList[this.CategoryIndex].CateId,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
        detail: this.CategoryList[this.CategoryIndex].Detail,
        gradeId: this.CycleList[this.CycleIndex].GradeId,
        classId: this.classList[this.classIndex].Id,
        cateId: this.CategoryList[this.CategoryIndex].CateId,
        studentIds: this.isBatch ? this.uId : [this.updateUser.StudentId],
        cycleId: this.CycleList[this.CycleIndex].Id,
      };
      this.$router.push({
        path: "/semesterTopic",
        query: {
          dateInfo: escape(JSON.stringify(dateInfo)),
        },
      });
    },
    //我已知晓的关闭按钮
    CloseDialoglabal(rows) {
      this.dialogVisiblelable = false;
    },
    //评价
    toTest(isBatch, row) {
      this.isBatch = isBatch;
      if (!isBatch) {
        this.updateUser = row;
      }
      if (this.CycleList[this.CycleIndex].IsBaby) {
        this.onSubmitLable();
      } else {
        this.dialogVisiblelable = true;
      }
    },
    toWrite(item) {
      this.updateUser = item;
      this.wordText = "";
      this.wordDialogVisible = true;
    },
    // 保存学期评价
    async AdminSaveTearMessageInfoByStudent() {
      if (this.wordText.length == 0) {
        this.$message.warning("请填写学期寄语");
        return;
      }
      let xhr = await AdminSaveTearMessageInfoByStudent({
        studyYearId: this.yearList[this.yearIndex].Id,
        cycleId: this.CycleList[this.CycleIndex].Id,
        gradeId: this.CycleList[this.CycleIndex].GradeId,
        classId: this.classList[this.classIndex].Id,
        studentId: this.updateUser.StudentId,
        stringInfo: this.wordText,
      });
      if (xhr.data.success) {
        // this.wordText = "";
        this.wordDialogVisible = false;
        this.$message.success("提交成功");
      } else {
        this.$message.success(xhr.data.msg);
      }
    },
    async AdminGetTearMessageInfoByStudent(item) {
      this.updateUser = item;
      let xhr = await AdminGetTearMessageInfoByStudent({
        StudyYearId: this.yearList[this.yearIndex].Id,
        CycleId: this.CycleList[this.CycleIndex].Id,
        GradeId: this.CycleList[this.CycleIndex].GradeId,
        ClassId: this.classList[this.classIndex].Id,
        CateId: this.CategoryList[this.CategoryIndex].CateId,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
        StudentId: item.StudentId,
      });
      this.wordDialogVisible = true;

      if (xhr.data.success) {
        this.wordText = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    toEditWrite() {},
    beforeAvatarUpload(file) {
      let type = file.type.split("/");
      //console.log(type);
      if (file.size > 1024 * 1024 * 2) {
        this.$message.warning("请保持在2M以内");
        return false;
      }
      if (type[0] == "image") {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (isLt2M) {
          if (!this.loading) {
            this.loading = this.$loading({
              lock: true,
              text: "上传中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
          }
          return true;
        } else {
          this.$message.error("上传头像图片大小不能超过 2MB!");
          return false;
        }
      } else {
        this.$message.warning("请上传视频");
        return false;
      }
    },
    handleUploadRemove(index) {
      //console.log(index);
      this.imgFilesLists.splice(index, 1);
    },
    // 文件上传变化
    handleFileChange(file, fileList) {
      this.imgFilesLists.push(file.response.response);
      //console.log(file, "fileList");
    },
    handleUploadSuccess(response, file, fileList) {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
      // //console.log(response, file, fileList, "response, file, fileList");
      this.handleFileChange(file, fileList);
    },
    dialogOpen() {},
    async proofadd(item) {
      console.log(item);
      this.StudentId = item.StudentId;
      this.updateUser = item;
      this.proofDialogVisible = true;
      this.imgFilesLists = [];
    },
    // 保存佐证评价
    async AdminSaveTearevalInfoByStudentCate() {
      let xhr = await AdminSaveTearevalInfoByStudentCate({
        studyYearId: this.yearList[this.yearIndex].Id,
        cycleId: this.CycleList[this.CycleIndex].Id,
        gradeId: this.CycleList[this.CycleIndex].GradeId,
        classId: this.classList[this.classIndex].Id,
        cateId: this.CategoryList[this.CategoryIndex].CateId,
        studentId: this.updateUser.StudentId,
        stringInfo: this.imgFilesLists.join(","),
      });
      if (xhr.data.success) {
        this.$message.success("提交成功");
        this.proofDialogVisible = false;
        this.imgFilesLists = [];
        this.AdminGetTestStatusInfo();
      } else {
        this.$message.success(xhr.data.msg);
      }
    },
    async AdminGetTearevalInfoByStudentCate(item) {
      console.log(item, "aaa");
      this.StudentId = item.StudentId;
      this.getCloudStorage();
      this.imgFilesLists = [];
      this.updateUser = item;
      let xhr = await AdminGetTearevalInfoByStudentCate({
        StudentId: item.StudentId,
        StudyYearId: this.yearList[this.yearIndex].Id,
        CycleId: this.CycleList[this.CycleIndex].Id,
        GradeId: this.CycleList[this.CycleIndex].GradeId,
        ClassId: this.classList[this.classIndex].Id,
        CateId: this.CategoryList[this.CategoryIndex].CateId,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
      });
      this.proofDialogVisible = true;
      if (xhr.data.success) {
        this.updateUser = item;
        let imageArr = xhr.data.response.split(",");
        imageArr.forEach((item) => {
          if (item) {
            this.imgFilesLists.push(item);
          }
        });
        this.proofDialogVisible = true;
      }
    },
    showCloudStorage() {
      this.innerVisible = true;
      this.getCloudStorage();
    },
    // 获取云盘照片
    async getCloudStorage() {
      let Dimension = 0;
      let CateName = this.CategoryList[this.CategoryIndex].CateName;
      if (CateName == "健康与体能") {
        Dimension = 1;
      } else if (CateName == "习惯与自理") {
        Dimension = 2;
      } else if (CateName == "自我与社会性") {
        Dimension = 3;
      } else if (CateName == "语言与交流") {
        Dimension = 4;
      } else if (CateName == "探究与认知") {
        Dimension = 5;
      } else if (CateName == "美感与表现") {
        Dimension = 6;
      }
      let xhr = await GetCloudFilePageingByFolderId({
        StudentId: this.StudentId,
        Dimension: Dimension,
        Type: 1, //文件类型 1.照片 2.视频
        IsClassFolder: 0,
        PageIndex: 1,
        PageSize: 100000000,
      });

      if (xhr.data.success) {
        xhr.data.response.data.forEach((element) => {
          element.isCheck = false;
        });
        this.CloudStorageImage = xhr.data.response.data;
      } else {
        this.CloudStorageImage = [];
      }
    },
    // 选择云盘图片
    selectImage(index) {
      this.CloudStorageImage[index].isCheck =
        !this.CloudStorageImage[index].isCheck;
    },
    // 确认选择云盘图片
    affirmSelectImage() {
      this.innerVisible = false;
      this.CloudStorageImage.forEach((item) => {
        if (item.isCheck) {
          if (this.imgFilesLists.length < 3) {
            this.imgFilesLists.push(item.FileUrl);
          }
          item.isCheck = false;
        }
      });
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.AdminGetTestStatusInfo();
    },
    //分页
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.AdminGetTestStatusInfo();
    },
    //判断是否可以勾选
    Selectable(row) {
      if (row.IsTest > 0) {
        return false;
      } else {
        return true;
      }
    },
    //多选
    handleSelectionChange(val) {
      //console.log(val);
      this.uId = [];
      val.forEach((item) => {
        this.uId.push(item.StudentId);
      });
      //console.log(this.uId);
    },
    // 获取学生列表
    async AdminGetTestStatusInfo() {
      if (!this.yearList[this.yearIndex]) {
        return;
      }
      if (!this.CycleList[this.CycleIndex]) {
        return;
      }
      if (!this.classList[this.classIndex]) {
        return;
      }
      if (!this.CategoryList[this.CategoryIndex]) {
        return;
      }
      this.studentList = [];
      let xhr = await AdminGetTestStatusInfo({
        Name: this.studentName ? this.studentName : undefined,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        StudyYearId: this.yearList[this.yearIndex].Id,
        CycleId: this.CycleList[this.CycleIndex].Id,
        GradeId: this.CycleList[this.CycleIndex].GradeId,
        ClassId: this.classList[this.classIndex].Id,
        CateId: this.CategoryList[this.CategoryIndex].CateId,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
      });
      if (xhr.data.success) {
        this.studentList = xhr.data.response.data;
        this.total = xhr.data.response.dataCount;
      }
    },
    // 获取学界列表
    async getAcademicSelect() {
      let UserIdentityArr = this.userInfo.UserIdentity.split(";");
      let isKindergarten = UserIdentityArr.find((item) => {
        return item == 1;
      });
      let xhr = await getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.yearList = xhr.data.response;
        this.yearIndex = 0;
        if (this.yearList.length != 0) {
          //   this.GetGradeSelect();
          this.GetOpenCycleInfoSelectResult();
        }
      } else {
        this.yearList = [];
      }
    },

    // 获取班级列表
    async GetClassSelect() {
      let xhr = await GetClassSelect({
        StudyYearId: this.yearList[this.yearIndex].Id,
        SchoolId: this.userInfo.SchoolId,
        GradeId: this.CycleList[this.CycleIndex].GradeId, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.classList = xhr.data.response;
        this.classIndex = 0;
      } else {
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },

    // 获取年级列表
    async GetGradeSelect() {
      let xhr = await GetGradeList({
        SchoolType: this.userInfo.SchoolType,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: this.yearList[this.yearIndex].Id,
        Uid: this.userInfo.uID,
      });
      if (xhr.data.success) {
        this.GradeList = xhr.data.response;
        this.GradeIndex = 0;
        if (this.GradeList.length != 0) {
          this.GetClassSelect();
        }
      } else {
        this.GradeList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    yearSelest(index) {
      this.yearIndex = index;
      this.GetOpenCycleInfoSelectResult();
    },
    GradeSelect(index) {
      this.GradeIndex = index;
      this.GetClassSelect();
    },
    //
    cateSelect(index) {
      this.CategoryIndex = index;
      this.AdminGetTestStatusInfo();
    },
    ClassSlect(index) {
      this.classIndex = index;
      this.AdminGetTestStatusInfo();
    },

    async CycleSelect(index) {
      this.CycleIndex = index;
      await this.GetClassSelect();
      await this.AdminGetAllCategory();
    },
    // 获取周期
    async GetOpenCycleInfoSelectResult() {
      let xhr = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.yearList[this.yearIndex].Id,
      });
      if (xhr.data.success) {
        this.CycleList = xhr.data.response;
        this.CycleIndex = 0;
        if (this.CycleList.length) {
          await this.GetClassSelect();
          await this.AdminGetAllCategory();
        }
      } else {
        this.CycleList = [];
        this.CategoryList = [];
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    async AdminGetAllCategory() {
      let xhr = await FrontGetQuestionCategoryNodes({
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
      });
      if (xhr.data.success) {
        xhr.data.response = xhr.data.response.filter((item) => {
          return item.Id != 0;
        });
        this.CategoryList = xhr.data.response;
        this.CategoryIndex = 0;
        this.PageIndex = 1;
        this.AdminGetTestStatusInfo();
      } else {
        this.CategoryList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  background-color: #ffffff;
}

.List {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .grade {
    position: relative;
    display: inline-block;
    min-width: 145px;
    height: 30px;
    border: 1px solid #cdcdcd;
    background: #e5ebff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 0 20px;
    box-sizing: border-box;
    line-height: 30px;
    color: #333333;
    cursor: pointer;
  }
  div {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .gradeActive {
    color: #ffffff;
    background: #5474e6;
    border: 1px solid #5474e6;
  }
}
.CloudStorageImageBox {
  display: flex;
  flex-wrap: wrap;
  .CloudStorageImageItem {
    width: 148px;
    height: 148px;
    position: relative;
    margin-top: 10px;
    margin-right: 10px;
    border: 1px #eeeeee solid;
    .check {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: #67c23a 1px solid;
      z-index: 2;
      position: absolute;
      top: 5px;
      right: 5px;
      div {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #67c23a;
        top: 50%;
        left: 50%;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
      }
    }
    img {
      width: 148px;
      height: 148px;
      object-fit: contain;
    }
  }
}
.UpdateBox {
  padding-top: 20px;
  display: flex;
  .el-icon-plus {
    display: block;
    width: 148px;
    height: 148px;
    font-size: 20px;
    border: 1px #ccc dashed;
    line-height: 148px;
    text-align: center;
  }
  .imageBox {
    position: relative;
    .deleteIcon {
      width: 20px;
      height: 20px;
      top: 0;
      right: 0;
      object-fit: contain;
      position: absolute;
      border: none;
    }
    img {
      object-fit: contain;
      border: 1px #ccc dashed;
      display: block;
      width: 148px;
      height: 148px;
      margin-right: 10px;
    }
  }
}
.statueTesting_title {
  font-size: 18px;
  font-family: PingFang SC;
  color: #333333;
  position: relative;
  padding-left: 20px;
}
.statueTesting_title::before {
  content: "";
  position: absolute;
  width: 6px;
  left: 0;
  top: 3px;
  height: 18px;
  background: #4cbff4;
  border-radius: 3px;
}
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.echartBox {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  .studentListBox {
    width: 200px;
    height: 400px;
    border: #ccc 1px solid;
    border-radius: 20px;
    overflow: hidden;
    .studentList {
      width: 220px;
      height: 420px;
      padding: 10px;
      overflow: scroll;
      box-sizing: border-box;
      .studentItem {
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
      }
      .studentItem div:nth-child(1) {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
.filtrateBox {
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
}
.contentBox {
  margin-top: 20px;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
}
.List {
  display: flex;
  div {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.btnList {
  display: flex;
  justify-content: flex-end;
  div {
    margin-left: 10px;
    margin-bottom: 10px;
  }
}
.elPopoverTable {
  cursor: pointer;
}
#histograms {
  width: 800px;
  height: 400px;
}
.TypeList {
  display: flex;
  justify-content: flex-end;
  div {
    margin-left: 20px;
  }
}

.canvasTitle {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.hintTable {
  width: 100%;
  height: auto;
}
</style>